import FieldEditor from "editor/FieldEditor";

class FieldEditorText extends FieldEditor {

    create() {
        if (this.$element.is(":input")) {
            this.$original = this.$element;

            let $div = eotwJSXFactory('div');
            this.$element = $div;

            this.$original.after($div).detach();

            // Copy all attributes into the settings
            /** @var {HTMLInputElement} original */
            const original = this.$original[0];

            for (let attribute of original.getAttributeNames()) {
                this.settings.attributes[attribute] = this.$original.attr(attribute);
            }
        } else {
            this.$original = null;
        }

        const $input = this.$input = $("<input>").addClass(this.settings.context === "admin-form" ? "admin-form__input" : "admin-editor admin-editor--text");
        let value = this.$element.text();

        if (this.settings.optional) {
            $input.attr("data-optional", true);
        }

        if (!value && this.settings.default) {
            value = this.settings.default;
        }
        this.setValue(value);

        this.$input.on("keyup change blur", () => {
            let value = this.getValue();
            if (value !== this.lastValue) {
                this.emit("change", value);
                this.valid();
            }
        }).on("focus", () => {
            return this.emit("focus");
        }).on("blur", () => {
            return this.emit("blur");
        });

        ["name", "placeholder"].forEach((attr) => {
            if ("undefined" !== typeof this.settings[attr]) {
                $input.attr(attr, this.settings[attr]);
            }
        });

        if ("object" === typeof this.settings.attributes) {
            $input.attr(this.settings.attributes);
        }
        if ("string" === typeof this.settings.type) {
            if (["text", "tel", "email"].indexOf(this.settings.type)) {
                $input.attr("type", this.settings.type);
            } else {
                $input.attr("data-type", this.settings.type);
            }
        }

        if (!$input.is("[type]")) $input.attr("type", "text");

        this.$element.html($input);
    }

    destroy() {
        super.destroy();

        if (this.$original !== null) {
            this.$element.after(this.$original.val(this.getValue()));
            this.$element.remove();
        } else {
            this.$element.text(this.getValue());
        }

        this.$original = null;
    }

    focus() {
        this.$input.focus();
    }

    getDefaultSettings() {
        return {
            optional: false,
            context: "",
            default: null,
            name: null,
            placeholder: null,
            attributes: {},
            type: "text",
        };
    }

    getValue() {
        return this.$input.val();
    }

    setValue(value) {
        this.lastValue = value;
        this.$input.val(value);
    }

    valid() {
        let valid = !this.$element.is("[data-required]") || this.getValue() !== "";

        if (!valid) {
            this.$input.addClass("admin-editor--invalid");
        } else {
            this.$input.removeClass("admin-editor--invalid");
        }

        return valid;
    }
}

FieldEditor.register_editor("text", FieldEditorText);

export default FieldEditorText;
